import styled from 'astroturf/react';

const PageTitle = styled('h1')`
  font-size: var(--ph-heading-three);
  font-weight: normal;
  color: var(--black);
  margin: 0;
  padding: 0;

  &.u-mb-20 {
    margin-bottom: 20px;
  }

  &.center {
    text-align: center;
  }

  &.second {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1.11;
    margin: 1.6rem 0;
  }

  &.error {
    display: flex;
    flex-direction: column;
    background: var(--white);
    border-radius: var(--ph-border-radius-md);
    box-shadow: var(--ph-box-shadow-sm);
    position: relative;
    top: 50%;
    transform: translate(0%, -50%);
    padding: 30px 60px;
    margin: 0 auto;
    text-align: center;
    z-index: 1;
    color: var(--black);
    width: max-content;
  }

  &.error a {
    width: 50%;
    margin: 30px auto 0;
    transition: var(--ph-button-transition);
    font-family: var(--ph-font-family-franklin-medium-regular);
    font-size: var(--ph-text-sm);
    color: var(--white);
    background-color: var(--ph-orange-500);
    border-radius: var(--ph-border-radius-sm);
    display: inline-flex;
    appearance: none;
    align-items: center;
    justify-content: center;
    user-select: none;
    touch-action: manipulation;
    text-transform: none;
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    line-height: 1.2;
    outline: none;
    height: 32px;
    min-width: 32px;
    padding-left: 12px;
    padding-right: 12px;
    border: 0;
    cursor: pointer;

    &:hover {
      background-color: var(--ph-orange-700);
    }

    &:active {
      background-color: var(--ph-orange-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }
`;

const PageContainer = styled('div')`
  padding: 20px;
  max-width: 100%;

  &.fullheight {
    height: 100%;
  }
`;

const PageContent = styled('div')`
  position: relative;

  &.spaced {
    margin-top: 30px;
  }

  &.spacedhalf {
    margin-top: 20px;
  }

  &.white {
    background-color: var(--white);
  }

  &.fullwidth {
    margin-left: -30px;
    margin-right: -30px;
  }

  &.doublefull {
    margin-left: -45px;
    margin-right: -60px;
  }

  &.doublepadding {
    padding: 30px 60px;
  }

  &.fullheight {
    height: 100%;
  }
`;

const PageMenu = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const PageAction = styled('div')`
  flex: 0 0 auto;
  margin-left: 20px;
  margin-top: 10px;

  &.auto {
    margin-left: auto;
  }
`;

const Page = styled('div')`
  position: relative;
  min-height: 100%;
  padding-bottom: 20px;
`;

export default {
  Page,
  PageTitle,
  PageContainer,
  PageContent,
  PageMenu,
  PageAction,
};
